import Image from "next/image";

/**
 * Carina partner wordmark above a partner name. The file is served as-is.
 */
export function CarinaPartnersPill() {
  return (
    <span
      className="mt-0.5 mb-3 inline-flex max-w-full items-center rounded-full bg-white px-2.5 pt-[6px] pb-1 ring-1 ring-black/10"
      data-testid="carina-partners-pill"
    >
      <Image
        src="/images/marketing/partners/carina/carinaPartner.webp"
        alt="Carina partner"
        width={1040}
        height={154}
        unoptimized
        className="h-5 w-auto md:h-6"
      />
    </span>
  );
}
